<template>
    <page-table/>
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'master-customer',
  components: {
    PageTable,
  },
}
</script>